export default {
  iosUrl: "itms-services://?action=download-manifest&url=https://asset.ncaicai.tech/app/nxl/nxl.plist",
  androidUrl: "https://asset.ncaicai.tech/app/nxl/nxl.apk",
  apiDomain: "https://www.xiayue.online",
  sharePrefix: "#nxl#",
};
